import { Component, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Endereco } from 'src/app/model/Endereco';
import { CarrinhoService } from 'src/app/service/carrinho.service';
import { StorageService } from 'src/app/service/shared/storage.service';
import { DialogItinerarioComponent } from 'src/app/shared/components/dialog-itinerario/dialog-itinerario.component';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import Tools from 'src/app/util/Tools';

@Component({
  selector: 'app-endereco-entrega',
  templateUrl: './endereco-entrega.component.html',
  styleUrls: ['./endereco-entrega.component.scss']
})
export class EnderecoEntregaComponent {
  public readonly aba: string = 'enderecoEntrega';

  public nome_escola!: string;

  public dependentes: any[] = [];
  public total: number = 0;
  public frete: number = 0;
  public dadosEscolaJSON = JSON.parse(this.storage.getEscola())

  private enderecoEntrega: Endereco = {
    endereco: this.dadosEscolaJSON.endereco,
    numero: this.dadosEscolaJSON.numero,
    bairro: this.dadosEscolaJSON.bairro,
    cidade: this.dadosEscolaJSON.cidade,
    estado: this.dadosEscolaJSON.estado,
    cep: Tools.removeNaoNumeros(this.dadosEscolaJSON.cep),
    complemento: this.dadosEscolaJSON.complemento,
    caixa_postal: '',
    telefone: Tools.removeNaoNumeros(this.dadosEscolaJSON.telefone),
    celular: '',
    aos_cuidados: ''
  }

  public endereco = `${this.dadosEscolaJSON.endereco}, ${this.dadosEscolaJSON.numero} - ${this.dadosEscolaJSON.bairro} - ${this.dadosEscolaJSON.cidade} - ${this.dadosEscolaJSON.estado} CEP: ${this.dadosEscolaJSON.cep}`

  public id_form_envio = JSON.parse(this.storage.getEscola()).id_forma_envio;

  public isLoading: boolean = true;

  public exibeBotaoContinuar = signal<boolean>(true);

  public displayedColumns: string[] = [
    'nome_dependente',
    'valor',
  ];
  public dataSource!: MatTableDataSource<any>;

  constructor(
    private router: Router,
    private storage: StorageService,
    private carrinho: CarrinhoService,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    if (this.storage.isloggedIn()) {
      this.nome_escola = JSON.parse(this.storage.getEscola()).nome_escola;
      this.carregaResumoDependentes()
      this.somaValorTotal();
      this.validaItinerario();
    } else {
      this.router.navigate(['/'])
    }
  }

  private carregaResumoDependentes() {
    this.carrinho.resumoCarrinho(this.storage.getGUID()).subscribe((dependentes) => {
      if (dependentes.length === 0) {
        this.router.navigate(['/dependente'])
      }

      this.dependentes = dependentes;
      this.dataSource = new MatTableDataSource<any>(this.dependentes);
      this.isLoading = false;
      this.somaValorTotal();
    });
  }

  private somaValorTotal() {
    this.total = 0;
    this.dependentes.forEach(item => {
      this.total += parseFloat(item.total);
    })
  }

  private enviaFormaEnvio() {
    const dados = {
      guid: this.storage.getGUID(),
      id_forma_envio: this.dadosEscolaJSON.id_forma_envio,
      endereco: this.enderecoEntrega,
      valor_frete: this.frete
    }

    this.carrinho.addEnderecoEntrega(dados).subscribe({
      next: (res) => {
        if (res.status) {
          this.router.navigate(['/forma-pagamento']);
        } else {
          this.dialog.open(DialogComponent, { data: res.mensagem })
            .afterClosed()
        }
      },
      error: (res) => this.dialog.open(DialogComponent, { data: res }).afterClosed()
    })
  }

  private validaItinerario(): void {
    this.carrinho.validaItinerario(this.storage.getGUID()).subscribe((res) => {
      if (!res.status) {
        return;
      } else {
        this.exibeBotaoContinuar.set(false);
        this.dialog.open(DialogItinerarioComponent, { data: res, maxWidth: '730px'})
      }
    });
  }

  public continuar() {
    this.enviaFormaEnvio();
  }
}
